export default function How(){
    return (
        <>
        <section className="py-5 sm:py-12 relative overflow-hidden">

            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-20">
                <div className="h-64 w-full" style={{
                    backgroundImage: `radial-gradient(circle, #3b82f6 1px, transparent 1px)`,
                    backgroundSize: '20px 20px'
                }}></div>
            </div>

            <div className="main-content w-[90%] sm:w-[90%] md:w-[85%] m-auto relative z-10">

                {/* Title */}
                <div className="text-center mb-12">
                    <h1 className="text-2xl md:text-3xl lg:text-4xl mx-auto font-extrabold text-blue-900 mb-4 max-w-3xl leading-snug text-center">
                        Como Funciona?
                    </h1>
                </div>

                {/* Steps */}
                <div className="max-w-4xl mx-auto">

                    {/* Step 1 */}
                    <div className="flex flex-col sm:flex-row items-start mb-8 sm:mb-12 relative">

                        <div className="flex-shrink-0 relative mb-4 sm:mb-0">
                            <div className="w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-br from-[#0a1a5f] to-[#002f9c] rounded-full flex items-center justify-center shadow-2xl">
                                <span className="text-lg sm:text-2xl font-bold text-white">1</span>
                            </div>

                            <div className="absolute top-12 sm:top-16 left-1/2 transform -translate-x-1/2 w-0.5 h-8 sm:h-16 bg-gradient-to-b from-[#0a1a5f] to-transparent"></div>
                        </div>

                        <div className="sm:ml-8 flex-1 w-full">
                            <div className="bg-white rounded-2xl p-4 sm:p-6 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">

                                <h3 className="text-lg sm:text-xl font-bold text-blue-900 mb-2 sm:mb-3 flex items-center">

                                    <svg className="w-5 h-5 sm:w-6 sm:h-6 text-[#0a1a5f] mr-2 sm:mr-3" fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z"/>
                                    </svg>

                                    Faz o teu Pedido
                                </h3>

                                <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                                    Escolhe a tua subscrição IPTV preferida entre os nossos planos premium.  
                                    Processo rápido e seguro com vários métodos de pagamento.
                                </p>

                            </div>
                        </div>

                    </div>

                    {/* Step 2 */}
                    <div className="flex flex-col sm:flex-row items-start mb-8 sm:mb-12 relative">

                        <div className="flex-shrink-0 relative mb-4 sm:mb-0">
                            <div className="w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-br from-[#002f9c] to-[#0d47ff] rounded-full flex items-center justify-center shadow-2xl">
                                <span className="text-lg sm:text-2xl font-bold text-white">2</span>
                            </div>

                            <div className="absolute top-12 sm:top-16 left-1/2 transform -translate-x-1/2 w-0.5 h-8 sm:h-16 bg-gradient-to-b from-[#0d47ff] to-transparent"></div>
                        </div>

                        <div className="sm:ml-8 flex-1 w-full">
                            <div className="bg-white rounded-2xl p-4 sm:p-6 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">

                                <h3 className="text-lg sm:text-xl font-bold text-blue-900 mb-2 sm:mb-3 flex items-center">

                                    <svg className="w-5 h-5 sm:w-6 sm:h-6 text-[#002f9c] mr-2 sm:mr-3" fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"/>
                                        <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"/>
                                    </svg>

                                    Recebe a tua Conta
                                </h3>

                                <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                                    Após o pagamento, receberás em menos de 10 minutos os teus dados de acesso 
                                    e o guia de instalação por e-mail. Ativação imediata!
                                </p>

                            </div>
                        </div>

                    </div>

                    {/* Step 3 */}
                    <div className="flex flex-col sm:flex-row items-start mb-8 sm:mb-16 relative">

                        <div className="flex-shrink-0 relative mb-4 sm:mb-0">
                            <div className="w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-br from-[#0d47ff] to-[#1d4ed8] rounded-full flex items-center justify-center shadow-2xl">
                                <span className="text-lg sm:text-2xl font-bold text-white">3</span>
                            </div>
                        </div>

                        <div className="sm:ml-8 flex-1 w-full">
                            <div className="bg-white rounded-2xl p-4 sm:p-6 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">

                                <h3 className="text-lg sm:text-xl font-bold text-blue-900 mb-2 sm:mb-3 flex items-center">

                                    <svg className="w-5 h-5 sm:w-6 sm:h-6 text-[#0d47ff] mr-2 sm:mr-3" fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"/>
                                    </svg>

                                    Desfruta do teu IPTV!
                                </h3>

                                <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                                    Começa imediatamente a assistir a todos os canais, filmes e séries.  
                                    Qualidade 4K / Full HD em todos os teus dispositivos.
                                </p>

                            </div>
                        </div>

                    </div>

                </div>

                {/* CTA */}
                <div className="text-center">
                    <div className="bg-white rounded-2xl p-4 sm:p-6 shadow-xl border border-gray-100 max-w-2xl mx-auto">

                        <h2 className="text-lg sm:text-xl font-bold text-blue-900 mb-3 sm:mb-4">
                            O Provedor IPTV Nº1 em Portugal e na Europa
                        </h2>

                        <button 
                            onClick={() => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })}
                            className="bg-gradient-to-r from-[#0a1a5f] via-[#002f9c] to-[#0d47ff] hover:from-[#002f9c] hover:to-[#0d47ff] text-white px-6 sm:px-8 py-2 sm:py-3 rounded-xl font-bold text-sm sm:text-lg transition-all duration-300 shadow-xl hover:shadow-2xl transform hover:scale-105"
                        >
                            Começar Agora
                        </button>

                    </div>
                </div>

            </div>
        </section>
        </>
    )
}